module.exports = __webpack_public_path__ + "img/close.65a6973f.svg";